import { createFileRoute } from '@tanstack/react-router';
import { PersonRelationshipsRoute } from './-route-wrappers';

/** The person profile's Relationships tab at its own URL (FPS-2712). */
function PersonRelationshipsIndexRoute() {
  return <PersonRelationshipsRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/relationships/')({
  component: PersonRelationshipsIndexRoute,
});
